(function () {
  var CACHE_KEY = 'themeBundleCompareCacheV3';

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeCache(cache) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (e) {
      /* ignore quota errors */
    }
  }

  function formatMoney(cents) {
    if (window.Currency && window.theme && window.theme.moneyFormat) {
      return window.Currency.formatMoney(cents, window.theme.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  // Parse the Fast Bundle offer for a bundle product out of its page HTML.
  // We need each component's id, quantity, and excluded (locked-out) variants
  // so we can price the bundle off the *default/locked* variant of every item.
  function extractBundleSpec(html) {
    var marker = 'let FastBundleFixedOffers = ';
    var start = html.indexOf(marker);

    if (start === -1) {
      return { items: [] };
    }

    start += marker.length;
    var end = html.indexOf('];', start);

    if (end === -1) {
      return { items: [] };
    }

    var offers;
    try {
      offers = JSON.parse(html.slice(start, end + 1));
    } catch (e) {
      return { items: [] };
    }

    if (!offers || !offers.length) {
      return { items: [] };
    }

    var offer = offers[0];
    var items = (offer.items || []).map(function (it) {
      return {
        productId: String(it.item_id),
        fbItemId: String(it.id),
        excluded: (it.excluded_variants || []).map(String),
        qty: it.quantity || 1
      };
    });

    return {
      items: items,
      bundleId: offer.id,
      uuid: offer.uuid,
      type: offer.type,
      useCartTransform: offer.bap_use_cart_transform !== false
    };
  }

  function fetchBundleSpec(handle) {
    var cache = readCache();
    var cacheEntry = cache[handle];

    if (cacheEntry && cacheEntry.spec) {
      return Promise.resolve(cacheEntry.spec);
    }

    return fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var spec = extractBundleSpec(html);
        cache = readCache();
        cache[handle] = cache[handle] || {};
        cache[handle].spec = spec;
        writeCache(cache);
        return spec;
      });
  }

  // First selectable (non-excluded) variant of a component = its default. When
  // only one variant remains after exclusions, that is the variant locked to
  // the bundle. Either way it's the variant the bundle is actually priced on.
  function defaultVariantFor(item, productVariants) {
    var variants = productVariants[item.productId] || [];
    var allowed = variants.filter(function (v) {
      return item.excluded.indexOf(v.id) === -1;
    });

    return allowed[0] || variants[0] || null;
  }

  // --- Live bundle pricing on the bundle product page -------------------------
  // Fast Bundle updates each component's line price when a variant changes, but
  // it does not update the bundle total shown by the theme. We recompute the
  // total (and compare-at) from the currently selected component variants.

  function parseOffersFromText(text) {
    var marker = 'let FastBundleFixedOffers = ';
    var start = text.indexOf(marker);

    if (start === -1) {
      return null;
    }

    start += marker.length;
    var end = text.indexOf('];', start);

    if (end === -1) {
      return null;
    }

    try {
      return JSON.parse(text.slice(start, end + 1));
    } catch (e) {
      return null;
    }
  }

  function getOfferForProduct(productId) {
    var offers = null;

    // The offer data is printed inline on the bundle product page. Read it
    // directly from the inline <script> contents (reliable across scopes)
    // rather than depending on the global binding being reachable.
    var scripts = document.querySelectorAll('script');
    for (var s = 0; s < scripts.length && !offers; s += 1) {
      var text = scripts[s].textContent || '';
      if (text.indexOf('FastBundleFixedOffers') !== -1) {
        offers = parseOffersFromText(text);
      }
    }

    if (!offers && typeof window !== 'undefined') {
      offers = window.FastBundleFixedOffers || null;
    }

    if (!offers || !offers.length) {
      return null;
    }

    for (var i = 0; i < offers.length; i += 1) {
      if (productId && String(offers[i].bap_product_id) === String(productId)) {
        return offers[i];
      }
    }

    return offers[0];
  }

  function idFromGid(gid) {
    return String(gid).split('/').pop();
  }

  // Shopify's cart endpoints (and Fast Bundle's own API) return 429/503 under
  // rate limiting or transient overload -- both retry-friendly, not real
  // failures. window.theme.fetchCartApiWithRetry is defined by theme.js
  // (always loaded first, per layout/theme.liquid); fall back to a plain
  // fetch if it is ever unavailable rather than fail outright.
  function fetchWithRetry(url, options) {
    if (window.theme && typeof window.theme.fetchCartApiWithRetry === 'function') {
      return window.theme.fetchCartApiWithRetry(url, options);
    }

    return fetch(url, options);
  }

  function fetchComponentVariants(productIds) {
    var token = window.FastBundleConf && window.FastBundleConf.storefront_access_token;
    var shopDomain = (window.FastBundleConf && window.FastBundleConf.domain) || (window.Shopify && window.Shopify.shop);

    if (!token || !shopDomain || !productIds.length) {
      return Promise.resolve({ variantMap: {}, productVariants: {} });
    }

    var gids = productIds.map(function (id) {
      return 'gid://shopify/Product/' + id;
    });

    var query = [
      'query BundleVariantPrices($ids: [ID!]!) {',
      '  nodes(ids: $ids) {',
      '    ... on Product {',
      '      id',
      '      variants(first: 100) {',
      '        nodes { id price { amount } compareAtPrice { amount } availableForSale quantityAvailable }',
      '      }',
      '    }',
      '  }',
      '}'
    ].join(' ');

    return fetch('https://' + shopDomain + '/api/2025-07/graphql.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query, variables: { ids: gids } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        var variantMap = {};
        var productVariants = {};
        var nodes = payload && payload.data && payload.data.nodes ? payload.data.nodes : [];

        nodes.forEach(function (node) {
          if (!node || !node.id || !node.variants || !node.variants.nodes) {
            return;
          }

          var productId = idFromGid(node.id);
          productVariants[productId] = [];

          node.variants.nodes.forEach(function (variant) {
            var variantId = idFromGid(variant.id);
            var priceCents = variant.price && variant.price.amount ? Math.round(parseFloat(variant.price.amount) * 100) : 0;
            var compareCents = variant.compareAtPrice && variant.compareAtPrice.amount ? Math.round(parseFloat(variant.compareAtPrice.amount) * 100) : 0;
            var entry = {
              id: variantId,
              productId: productId,
              price: priceCents,
              compareAt: compareCents,
              available: variant.availableForSale !== false,
              quantityAvailable: typeof variant.quantityAvailable === 'number' ? variant.quantityAvailable : null
            };

            productVariants[productId].push(entry);
            variantMap[variantId] = entry;
          });
        });

        return { variantMap: variantMap, productVariants: productVariants };
      });
  }

  // Keep a savings label ("Save $X (Y%)") in sync next to a bundle price block.
  // It is added as the price element's sibling so re-rendering the price (which
  // replaces innerHTML) does not wipe it. Removed when there is no saving.
  function renderBundleSavings(priceList, sellingCents, compareCents) {
    var label = null;
    var next = priceList.nextElementSibling;

    if (next && next.classList && next.classList.contains('product-meta__bundle-savings')) {
      label = next;
    }

    var saving = compareCents - sellingCents;

    if (compareCents && saving > 0) {
      var percent = Math.round((saving / compareCents) * 100);
      var text = 'Save ' + formatMoney(saving) + ' (' + percent + '%)';

      if (!label) {
        label = document.createElement('div');
        label.className = 'product-meta__bundle-savings';

        if (priceList.parentNode) {
          priceList.parentNode.insertBefore(label, priceList.nextSibling);
        }
      }

      label.innerHTML = '<span class="savings-text">' + text + '</span>';
    } else if (label && label.parentNode) {
      label.parentNode.removeChild(label);
    }
  }

  function renderBundlePrice(priceList, sellingCents, compareCents) {
    var html = '<span class="price price--highlight">' + formatMoney(sellingCents) + '</span>';

    if (compareCents && compareCents > sellingCents) {
      html += '<span class="price price--compare">' + formatMoney(compareCents) + '</span>';
    }

    priceList.innerHTML = html;
    priceList.removeAttribute('data-bundle-needs-compare');

    renderBundleSavings(priceList, sellingCents, compareCents);
  }

  // Grey out (disable) the bundle's add-to-cart button when a required
  // component is out of stock, and restore it when back in stock. The bundle's
  // own BAP variant always reports as available, so stock has to be enforced
  // from the component variants we already fetched for pricing.
  function setBundleSoldOut(soldOut) {
    var buttons = document.querySelectorAll('.product-form__add-button[data-action="add-to-cart"]');

    Array.prototype.forEach.call(buttons, function (btn) {
      if (soldOut) {
        if (!btn.hasAttribute('data-in-stock-label')) {
          btn.setAttribute('data-in-stock-label', btn.innerHTML);
        }

        var soldOutLabel = btn.getAttribute('data-sold-out-label') || 'Sold Out';

        btn.classList.add('button--disabled');
        btn.classList.remove('button--primary');
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = soldOutLabel;
      } else if (btn.hasAttribute('data-in-stock-label')) {
        btn.innerHTML = btn.getAttribute('data-in-stock-label');
        btn.removeAttribute('data-in-stock-label');
        btn.classList.remove('button--disabled');
        btn.classList.add('button--primary');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    });

    // The dynamic checkout (Shop Pay / "Buy it now") button bypasses the cart,
    // so hide it too while any component is unavailable.
    var paymentButtons = document.querySelectorAll('.product-form .shopify-payment-button');
    Array.prototype.forEach.call(paymentButtons, function (payment) {
      payment.style.display = soldOut ? 'none' : '';
    });
  }

  function setupBundlePageLivePricing(priceList) {
    var productId = priceList.getAttribute('data-product-id');
    var dataProductPrice = parseInt(priceList.getAttribute('data-product-price'), 10) || 0;
    var offer = getOfferForProduct(productId);

    if (!offer || !offer.items || !offer.items.length) {
      return enhanceBundlePageFallback(priceList);
    }

    var items = offer.items.map(function (it) {
      return {
        productId: String(it.item_id),
        excluded: (it.excluded_variants || []).map(String),
        qty: it.quantity || 1
      };
    });

    var productIds = items.map(function (i) {
      return i.productId;
    });

    return fetchComponentVariants(productIds)
      .then(function (data) {
        var variantMap = data.variantMap;
        var productVariants = data.productVariants;

        if (!Object.keys(variantMap).length) {
          return enhanceBundlePageFallback(priceList);
        }

        // Default variant per component = first variant that isn't excluded.
        var defaults = {};
        items.forEach(function (it) {
          var variants = productVariants[it.productId] || [];
          var allowed = variants.filter(function (v) {
            return it.excluded.indexOf(v.id) === -1;
          });
          var def = allowed[0] || variants[0];

          if (def) {
            defaults[it.productId] = def.id;
          }
        });

        var handle = priceList.getAttribute('data-product-handle');
        var rendering = false;

        // Baseline = the variant combination actually selected when the page is
        // at its default state. We capture it once the Fast Bundle selects exist
        // so the anchored price matches exactly what the app charges by default.
        var baseline = null;

        // Fast Bundle clones the theme price/title block into its widget, so
        // there can be more than one price element representing this bundle.
        // Update every matching one (the original and any clone).
        function getTargets() {
          var list = [];

          if (handle) {
            list = document.querySelectorAll('.product-meta__price[data-product-handle="' + handle + '"]');
          }

          return list.length ? list : [priceList];
        }

        // The first option of a Fast Bundle variant <select> that maps to a
        // known variant is the component's default selection.
        function getSelectDefault(sel) {
          for (var i = 0; i < sel.options.length; i++) {
            if (variantMap[sel.options[i].value]) {
              return sel.options[i].value;
            }
          }

          return null;
        }

        // Resolve the current selection per component, reading any variant
        // <select> the app has injected and falling back to the defaults.
        function resolveSelected() {
          var selected = {};
          Object.keys(defaults).forEach(function (pid) {
            selected[pid] = defaults[pid];
          });

          var hasSelect = false;
          var selects = document.querySelectorAll('select');
          Array.prototype.forEach.call(selects, function (sel) {
            var v = variantMap[sel.value];
            if (v) {
              selected[v.productId] = sel.value;
              hasSelect = true;
            }
          });

          return { selected: selected, hasSelect: hasSelect };
        }

        // Build the default combination deterministically from the first real
        // option of each select, so it never depends on what is currently
        // selected when we happen to run (avoids a race with user changes).
        function buildBaseline() {
          var base = {};
          Object.keys(defaults).forEach(function (pid) {
            base[pid] = defaults[pid];
          });

          var selects = document.querySelectorAll('select');
          Array.prototype.forEach.call(selects, function (sel) {
            var def = getSelectDefault(sel);
            var v = def && variantMap[def];
            if (v) {
              base[v.productId] = def;
            }
          });

          return base;
        }

        function recompute() {
          var resolved = resolveSelected();
          var selected = resolved.selected;

          // Once real selects are present, lock in the default combination as
          // the baseline we anchor pricing against.
          if (!baseline && resolved.hasSelect) {
            baseline = buildBaseline();
          }

          var base = baseline || defaults;
          var sellingDelta = 0;
          var compare = 0;
          var soldOut = false;

          items.forEach(function (it) {
            var sv = variantMap[selected[it.productId]] || variantMap[defaults[it.productId]];
            var bv = variantMap[base[it.productId]] || variantMap[defaults[it.productId]];

            if (sv && bv) {
              sellingDelta += (sv.price - bv.price) * it.qty;
            }

            if (sv) {
              compare += (sv.compareAt || sv.price) * it.qty;
            }

            // A bundle can only be sold when every required component variant is
            // in stock (and, when inventory is tracked, has enough on hand).
            if (sv && (sv.available === false || (typeof sv.quantityAvailable === 'number' && sv.quantityAvailable < it.qty))) {
              soldOut = true;
            }
          });

          setBundleSoldOut(soldOut);

          // Anchor the selling price to what Fast Bundle charges for the default
          // combination and apply only the difference from the selected variants.
          var sellingFinal = Math.round(dataProductPrice + sellingDelta);

          rendering = true;
          Array.prototype.forEach.call(getTargets(), function (el) {
            renderBundlePrice(el, sellingFinal, compare);
          });
          rendering = false;
        }

        recompute();

        document.addEventListener('change', function (event) {
          var target = event.target;
          if (target && target.tagName === 'SELECT' && variantMap[target.value]) {
            recompute();
          }
        });

        // The widget clone is injected after we first run, so re-sync it the
        // moment a new price block shows up in the DOM.
        if (typeof MutationObserver !== 'undefined') {
          var observer = new MutationObserver(function (mutations) {
            if (rendering) {
              return;
            }

            var sawPrice = false;
            mutations.forEach(function (mutation) {
              Array.prototype.forEach.call(mutation.addedNodes, function (node) {
                if (node.nodeType !== 1 || sawPrice) {
                  return;
                }

                if (node.classList && node.classList.contains('product-meta__price')) {
                  sawPrice = true;
                } else if (node.querySelector && node.querySelector('.product-meta__price')) {
                  sawPrice = true;
                }
              });
            });

            if (sawPrice) {
              recompute();
            }
          });

          observer.observe(document.body, { childList: true, subtree: true });
        }
      })
      .catch(function () {
        return enhanceBundlePageFallback(priceList);
      });
  }

  function applyComparePricing(priceList, bundlePriceCents, compareCents, card) {
    if (!compareCents || compareCents <= bundlePriceCents) {
      return;
    }

    if (!priceList || priceList.querySelector('.price--compare')) {
      return;
    }

    priceList.innerHTML =
      '<span class="price price--highlight">' + formatMoney(bundlePriceCents) + '</span>' +
      '<span class="price price--compare">' + formatMoney(compareCents) + '</span>';

    priceList.removeAttribute('data-bundle-needs-compare');

    // Savings label + cart data attributes only apply to collection cards.
    if (!card) {
      return;
    }

    card.setAttribute('data-product-compare-at-price', compareCents);

    var hiddenInput = card.querySelector('input[name="id"][data-compare-at-price]');

    if (hiddenInput) {
      hiddenInput.setAttribute('data-compare-at-price', compareCents);
    }

    var savingsAmount = compareCents - bundlePriceCents;
    var savingsPercent = Math.round((savingsAmount / compareCents) * 100);
    var existingSavingsLabel = card.querySelector('[data-savings-label]');

    if (existingSavingsLabel) {
      existingSavingsLabel.innerHTML = '<span class="savings-text">Save ' + formatMoney(savingsAmount) + ' (' + savingsPercent + '%)</span>';
    } else {
      var savingsLabel = document.createElement('div');
      // Render as a corner badge in the card's top-left, where the native
      // on-sale "Save %" badge would normally appear (the card is the
      // positioned ancestor, so absolute positioning anchors to it).
      savingsLabel.className = 'product-item__savings-label product-item__savings-label--corner';
      savingsLabel.setAttribute('data-savings-label', '');
      savingsLabel.innerHTML = '<span class="savings-text">Save ' + formatMoney(savingsAmount) + ' (' + savingsPercent + '%)</span>';

      card.insertBefore(savingsLabel, card.firstChild);
    }
  }

  // Bundle compare-at = the sum of each component's *default/locked* variant
  // compare-at price (falling back to its price when not on sale), times the
  // component quantity. This is the true retail "was" total, independent of any
  // additional bundle discount baked into the bundle product's own price.
  function resolveCompareCents(handle) {
    var cache = readCache();
    var cacheEntry = cache[handle];

    if (cacheEntry && cacheEntry.compareCents) {
      return Promise.resolve(cacheEntry.compareCents);
    }

    return fetchBundleSpec(handle)
      .then(function (spec) {
        if (!spec.items.length) {
          return 0;
        }

        var productIds = spec.items.map(function (it) {
          return it.productId;
        });

        return fetchComponentVariants(productIds).then(function (data) {
          var total = 0;

          spec.items.forEach(function (it) {
            var def = defaultVariantFor(it, data.productVariants);
            if (def) {
              total += (def.compareAt || def.price) * it.qty;
            }
          });

          return total;
        });
      })
      .then(function (compareCents) {
        if (compareCents) {
          cache = readCache();
          cache[handle] = cache[handle] || {};
          cache[handle].compareCents = compareCents;
          writeCache(cache);
        }

        return compareCents;
      });
  }

  function enhanceBundleCard(card) {
    var priceList = card.querySelector('.product-item__price-list[data-bundle-needs-compare="true"]');

    if (!priceList) {
      return Promise.resolve();
    }

    var handle = card.getAttribute('data-product-handle');
    var bundlePriceCents = parseInt(card.getAttribute('data-product-price'), 10) || 0;

    if (!handle || !bundlePriceCents) {
      return Promise.resolve();
    }

    return resolveCompareCents(handle, bundlePriceCents)
      .then(function (compareCents) {
        if (compareCents) {
          applyComparePricing(priceList, bundlePriceCents, compareCents, card);
        }
      })
      .catch(function () {
        /* leave plain price if enhancement fails */
      });
  }

  function enhanceBundlePageFallback(priceList) {
    var handle = priceList.getAttribute('data-product-handle');
    var bundlePriceCents = parseInt(priceList.getAttribute('data-product-price'), 10) || 0;

    if (!handle || !bundlePriceCents) {
      return Promise.resolve();
    }

    return resolveCompareCents(handle, bundlePriceCents)
      .then(function (compareCents) {
        if (compareCents) {
          applyComparePricing(priceList, bundlePriceCents, compareCents, null);
        }
      })
      .catch(function () {
        /* leave plain price if enhancement fails */
      });
  }

  // --- Quick add-to-cart for bundle cards --------------------------------------
  // A Bundle-as-Product variant can't be POSTed to /cart/add directly: Fast
  // Bundle's cart transform validation rejects it (422). On the bundle page the
  // app intercepts the form submit and instead (1) registers the selection with
  // its API to get a __cartBundleId, then (2) adds the component variants with
  // that property, which the cart transform merges back into a single bundle
  // line (the BAP variant) at the bundle price. Quick add replicates that flow
  // using each component's default/locked variant.

  function getShopDomain() {
    return (window.Shopify && window.Shopify.shop) ||
      (window.FastBundleConf && window.FastBundleConf.shop_domain);
  }

  function markCardButtonSoldOut(button) {
    button.textContent = button.getAttribute('data-sold-out-label') || 'Sold Out';
    button.classList.add('button--disabled');
    button.classList.remove('button--primary');
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-disabled', 'true');
  }

  // Default variant for every component, so quick add matches the bundle page's
  // default state. Returns { soldOut: true } when a required component variant
  // is unavailable (the BAP variant itself always reports as available).
  function resolveBundleSelections(spec) {
    var productIds = spec.items.map(function (it) {
      return it.productId;
    });

    return fetchComponentVariants(productIds).then(function (data) {
      var selections = [];

      for (var i = 0; i < spec.items.length; i += 1) {
        var item = spec.items[i];
        var variant = defaultVariantFor(item, data.productVariants);

        if (!variant) {
          return null;
        }

        if (!variant.available) {
          return { soldOut: true };
        }

        selections.push({ item: item, variant: variant });
      }

      return { selections: selections };
    });
  }

  // The cart is materialized via POST /cart/update.js: on a fresh session
  // GET /cart.js only returns an ephemeral placeholder token (no "?key="), and
  // a bundle registered against it can't be matched by the cart transform, so
  // the component lines would be silently dropped from the cart. If the update
  // response isn't JSON (e.g. a bot-protection interstitial), fall back to
  // reading the token from GET /cart.js.
  function getDurableCartToken() {
    return fetchWithRetry('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {} })
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        try {
          return JSON.parse(text).token || null;
        } catch (e) {
          return null;
        }
      })
      .catch(function () {
        return null;
      })
      .then(function (token) {
        if (token) {
          return token;
        }

        return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            return cart.token || null;
          })
          .catch(function () {
            return null;
          });
      });
  }

  // Register the selection with Fast Bundle to obtain the __cartBundleId that
  // its cart transform uses to merge the component lines into the bundle.
  function registerCartBundle(spec, selections) {
    return getDurableCartToken()
      .then(function (token) {
        if (!token) {
          throw new Error('register: no cart token available');
        }

        return { token: token };
      })
      .then(function (cart) {
        var bundleVariants = [];

        selections.forEach(function (sel) {
          for (var n = 0; n < sel.item.qty; n += 1) {
            bundleVariants.push({ variant_id: Number(sel.variant.id), item_id: sel.item.fbItemId });
          }
        });

        return fetchWithRetry('https://api.fastbundle.co/v1/carts/bundles/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: cart.token,
            bundle: spec.bundleId,
            show_uuid: spec.uuid,
            shop: getShopDomain(),
            user_ip: '',
            click_from_url: window.location.pathname,
            click_from_page_type: (window.theme && window.theme.pageType) || 'collection',
            bundle_variants: bundleVariants,
            is_single_bap: false
          })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('register: HTTP ' + response.status);
        }

        return response.json();
      })
      .then(function (payload) {
        if (!payload || !payload.id) {
          throw new Error('register: no id in response');
        }

        return payload.id;
      })
      .catch(function (error) {
        throw new Error(error && error.message && error.message.indexOf('register:') === 0 ? error.message : 'register: ' + (error && error.message ? error.message : 'network error'));
      });
  }

  function addBundleComponents(selections, cartBundleId) {
    var byVariant = {};

    selections.forEach(function (sel) {
      var key = String(sel.variant.id);

      if (!byVariant[key]) {
        byVariant[key] = {
          id: key,
          product_id: sel.item.productId,
          quantity: 0,
          properties: { __cartBundleId: String(cartBundleId) }
        };
      }

      byVariant[key].quantity += sel.item.qty;
    });

    var items = Object.keys(byVariant).map(function (key) {
      return byVariant[key];
    });

    // The header stops Fast Bundle's own fetch overrides (active on bundle
    // pages) from re-intercepting this request.
    return fetchWithRetry('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Fastbundle-Request': 'yes'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json()
          .catch(function () {
            return {};
          })
          .then(function (err) {
            throw new Error('add: HTTP ' + response.status + ' ' + (err.description || err.message || ''));
          });
      }

      // The response already contains the transform-merged bundle line.
      return response.json().then(function (payload) {
        return (payload && payload.items) || [];
      });
    });
  }

  function waitFor(condition, maxMs) {
    return new Promise(function (resolve) {
      var start = Date.now();

      (function poll() {
        if (condition()) {
          resolve(true);
        } else if (Date.now() - start >= maxMs) {
          resolve(false);
        } else {
          setTimeout(poll, 100);
        }
      })();
    });
  }

  // The storefront token arrives with Fast Bundle's app embed; when a click
  // beats it, wait briefly instead of failing the add.
  function waitForStorefrontToken(maxMs) {
    return waitFor(function () {
      return !!(window.FastBundleConf && window.FastBundleConf.storefront_access_token);
    }, maxMs);
  }

  // Fast Bundle's cart script (api.fastbundle.co/scripts/cart.js) snapshots the
  // cart when it initializes and syncs that state to its backend. If it boots
  // *after* our add with a stale (pre-add) snapshot, its cleanup can drop the
  // just-added bundle lines. Waiting for it (best effort) orders its initial
  // sync before our add, like on the bundle product page. Without the script
  // (blocked / failed) the server-side cart transform still merges fine.
  function waitForBundleCartScript(maxMs) {
    return waitFor(function () {
      return typeof window.detectBundleDiscounts === 'function';
    }, maxMs);
  }

  // The merged bundle line can be removed moments after a successful add if
  // Fast Bundle's cart script initialized against a stale cart snapshot and
  // treats the fresh component lines as orphaned. Verify the line actually
  // survived; the caller retries once when it did not.
  function verifyBundleInCart(cartBundleId, bapVariantId) {
    return new Promise(function (resolve) {
      setTimeout(resolve, 1800);
    })
      .then(function () {
        return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return (cart.items || []).some(function (item) {
          if (bapVariantId && item.variant_id === bapVariantId) {
            return true;
          }

          return !!(item.properties && String(item.properties.__cartBundleId) === String(cartBundleId));
        });
      })
      .catch(function () {
        // Can't verify -> assume it worked rather than double-adding.
        return true;
      });
  }

  // needsVerify: the drop race only exists when Fast Bundle's cart script had
  // not initialized before our add (it can boot against a stale snapshot and
  // strip the fresh lines). When the script was already up we skip
  // verification entirely so a shopper removing the bundle right after adding
  // is never fought by a re-add.
  function performBundleAdd(spec, selections, bapVariantId, needsVerify) {
    return registerCartBundle(spec, selections)
      .then(function (cartBundleId) {
        return addBundleComponents(selections, cartBundleId).then(function (addedItems) {
          if (!needsVerify) {
            return { survived: true, items: addedItems, cartBundleId: cartBundleId };
          }

          return verifyBundleInCart(cartBundleId, bapVariantId).then(function (survived) {
            return { survived: survived, items: addedItems, cartBundleId: cartBundleId };
          });
        });
      });
  }

  function pickBundleLine(items, bapVariantId) {
    if (!items || !items.length) {
      return null;
    }

    for (var i = 0; i < items.length; i += 1) {
      if (bapVariantId && items[i].variant_id === bapVariantId) {
        return items[i];
      }
    }

    return items[0];
  }

  // Resolve the bundle's merged cart line with settled pricing before handing
  // it to the theme. Two async processes have to finish server-side first:
  // the cart transform merge (under rapid adds the add response still shows
  // loose component lines; any cart mutation re-runs the transform, so a no-op
  // update nudges it) and Fast Bundle's extra discount, which is applied as a
  // cart-level discount moments after the add -- the add response reports the
  // pre-discount price, which briefly showed a too-high amount in the drawer.
  // Poll the cart until the line's final price matches the price the card
  // advertises (small tolerance for the app's rounding), or time out and use
  // whatever the cart says.
  function resolveMergedLine(addedItems, bapVariantId, cartBundleId, expectedUnitPrice) {
    var direct = pickBundleLine(addedItems, bapVariantId);
    var needsNudge = !!(bapVariantId && (!direct || direct.variant_id !== bapVariantId));

    function findLine(items) {
      for (var i = 0; i < items.length; i += 1) {
        if (bapVariantId && items[i].variant_id === bapVariantId) {
          return items[i];
        }

        if (cartBundleId && items[i].properties && String(items[i].properties.__cartBundleId) === String(cartBundleId)) {
          return items[i];
        }
      }

      return null;
    }

    function priceSettled(line) {
      if (!expectedUnitPrice) {
        return true;
      }

      return Math.abs((line.final_price || 0) - expectedUnitPrice) <= 2;
    }

    // Fast Bundle's discount PATCH landing can take longer than expected under
    // real-world latency (observed 1-3.5s locally; production could be
    // slower under load). The original 4-attempt/~2.8s budget could time out
    // before it lands, confirming the line at the pre-discount price shown
    // right after /cart/add.js -- exactly the "wrong number, then eventually
    // corrects" symptom, since nothing else re-checks it afterwards. Widened
    // to 9 attempts (~6.5s total). As a second line of defense against the
    // advertised card price itself being stale (so priceSettled() could never
    // match), also accept once the price has stopped changing across two
    // consecutive polls and differs from the original pre-discount price --
    // i.e. Fast Bundle visibly finished adjusting it, even if the exact
    // number does not match what the card predicted.
    var lastSeenPrice = direct ? direct.final_price : null;
    var priceChangedAtLeastOnce = false;

    function attempt(remaining, nudge) {
      var request = nudge
        ? fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: {} })
          })
        : fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' });

      return request
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var line = findLine(cart.items || []);

          if (line && priceSettled(line)) {
            return line;
          }

          if (line) {
            var thisPrice = line.final_price || 0;

            if (lastSeenPrice !== null && thisPrice !== lastSeenPrice) {
              priceChangedAtLeastOnce = true;
            }

            if (remaining <= 0 && priceChangedAtLeastOnce && thisPrice === lastSeenPrice) {
              return line;
            }

            lastSeenPrice = thisPrice;
          }

          if (remaining <= 0) {
            return line || direct;
          }

          return new Promise(function (resolve) {
            setTimeout(resolve, 700);
          }).then(function () {
            return attempt(remaining - 1, false);
          });
        })
        .catch(function () {
          return direct;
        });
    }

    return attempt(9, needsNudge);
  }

  var quickAddBusy = {};

  // Concurrent bundle adds corrupt the cart: Fast Bundle's transform merges
  // the first bundle's component lines but leaves the overlapping second add
  // unmerged, and the app's cleanup then strips those loose lines entirely.
  // Serializing the network flow (the optimistic preview still shows
  // immediately per click) makes rapid multi-adds reliable.
  //
  // This queue is shared with theme.js's Cart class (window.theme.
  // enqueueCartMutation), not just used locally: without that, a regular
  // add/remove/quantity-change elsewhere on the page could fire its own
  // /cart.js GET while a bundle add is mid-flight -- registered with Fast
  // Bundle but not yet merged by its cart transform -- and render that
  // transient, not-yet-settled state (loose component lines that vanish once
  // the real merge lands moments later). Falls back to a local-only queue if
  // theme.js hasn't defined it yet, though layout/theme.liquid always loads
  // theme.js first.
  var localQuickAddChain = Promise.resolve();

  function enqueueQuickAdd(task) {
    if (window.theme && typeof window.theme.enqueueCartMutation === 'function') {
      return window.theme.enqueueCartMutation(task);
    }

    var run = localQuickAddChain.then(task, task);
    // Keep the chain alive whether or not this add failed.
    localQuickAddChain = run.then(function () {}, function () {});
    return run;
  }

  function quickAddLog(step, detail) {
    try {
      var entry = '[bundle-quick-add] ' + step + (detail ? ': ' + detail : '');
      console.warn(entry);
      sessionStorage.setItem('bundleQuickAddLastError', entry + ' @ ' + new Date().toISOString());
    } catch (e) {
      /* ignore */
    }
  }

  // Temporary field diagnostic: surface the failing step right on the card so
  // shoppers/testers can report it without opening the console.
  function showQuickAddError(button, message) {
    try {
      var existing = button.parentNode.querySelector('.bundle-quick-add-error');

      if (existing) {
        existing.remove();
      }

      var note = document.createElement('div');
      note.className = 'bundle-quick-add-error';
      note.setAttribute('style', 'color:#c0392b;font-size:11px;line-height:1.3;margin-top:4px;text-align:center;');
      note.textContent = message;
      button.insertAdjacentElement('afterend', note);

      setTimeout(function () {
        if (note.parentNode) {
          note.remove();
        }
      }, 15000);
    } catch (e) {
      /* ignore */
    }
  }

  function quickAddBundle(button) {
    var card = button.closest('.product-item[data-is-bundle="true"]');

    if (!card) {
      return;
    }

    var handle = card.getAttribute('data-product-handle');

    if (!handle || quickAddBusy[handle]) {
      return;
    }

    var idInput = card.querySelector('form[action*="/cart/add"] [name="id"]');
    var bapVariantId = idInput ? parseInt(idInput.value, 10) || null : null;
    var productUrl = card.getAttribute('data-product-url') || '';

    quickAddBusy[handle] = true;
    button.setAttribute('disabled', 'disabled');

    // Optimistic pending line in the mini-cart drawer: the cart transform
    // merges the components back into the BAP variant, so previewing that
    // variant matches the final server line and gets reconciled in place.
    //
    // The card's price attribute is the BAP variant price, which can lag the
    // cart transform's actual output between Fast Bundle price syncs. Prefer
    // the final price confirmed by a previous add this session so the preview
    // doesn't briefly show a stale (usually higher) amount.
    if (bapVariantId) {
      var cachedFinalUnit = 0;

      try {
        cachedFinalUnit = parseInt((readCache()[handle] || {}).finalUnitPrice, 10) || 0;
      } catch (e) {
        /* ignore */
      }

      // vendor/handle mark the line as a bundle for theme.js, which suppresses
      // the BAP variant's own compare-at (it only reflects the extra bundle
      // discount, e.g. a misleading "$84.88" strike next to a $80.64 price).
      // The true retail "was" price is filled in by enhanceCartBundleLines
      // from the component variants.
      document.documentElement.dispatchEvent(new CustomEvent('cart:add-start', {
        bubbles: true,
        detail: {
          previewLine: {
            variant_id: bapVariantId,
            key: 'pending-' + bapVariantId,
            quantity: 1,
            final_line_price: cachedFinalUnit || parseInt(card.getAttribute('data-product-price'), 10) || 0,
            compare_at_price: 0,
            vendor: 'Fast Bundle',
            handle: handle,
            product_title: card.getAttribute('data-product-title') || '',
            url: card.getAttribute('data-product-url') || '',
            image: card.getAttribute('data-product-image') || '',
            isFreight: false
          }
        }
      }));
    }

    var finalize = function () {
      delete quickAddBusy[handle];

      if (!button.hasAttribute('aria-disabled')) {
        button.removeAttribute('disabled');
      }
    };

    var soldOut = false;
    // If Fast Bundle's cart script is already up at click time there is no
    // boot race to defend against, so the add can skip post-add verification.
    var needsVerify = typeof window.detectBundleDiscounts !== 'function';

    enqueueQuickAdd(function () {
      return waitForStorefrontToken(5000)
      .then(function () {
        return waitForBundleCartScript(5000);
      })
      .then(function () {
        return fetchBundleSpec(handle);
      })
      .then(function (spec) {
        if (!spec || !spec.items.length || !spec.bundleId) {
          throw new Error('spec: missing offer data for ' + handle);
        }

        return resolveBundleSelections(spec).then(function (result) {
          if (!result || !result.selections) {
            if (result && result.soldOut) {
              soldOut = true;
              markCardButtonSoldOut(button);
              throw new Error('variants: component sold out');
            }

            throw new Error('variants: could not resolve component variants (token ' + (window.FastBundleConf && window.FastBundleConf.storefront_access_token ? 'present' : 'missing') + ')');
          }

          return performBundleAdd(spec, result.selections, bapVariantId, needsVerify).then(function (outcome) {
            if (outcome.survived) {
              return outcome;
            }

            quickAddLog('retry for ' + handle, 'bundle line disappeared after add, retrying once');
            return performBundleAdd(spec, result.selections, bapVariantId, true).then(function (retryOutcome) {
              if (!retryOutcome.survived) {
                throw new Error('verify: bundle line dropped from cart twice');
              }

              return retryOutcome;
            });
          });
        });
      })
      .then(function (outcome) {
        finalize();

        if (typeof window.detectBundleDiscounts === 'function') {
          window.detectBundleDiscounts();
        }

        // Hand the merged line to the theme's native post-add path
        // (confirm-optimistic + gentle reconcile). This avoids the full drawer
        // re-render that made rapid adds/removals flicker, and keeps the
        // header cart count in sync like a regular product add.
        var expectedUnit = parseInt(card.getAttribute('data-product-price'), 10) || 0;

        return resolveMergedLine(outcome.items, bapVariantId, outcome.cartBundleId, expectedUnit).then(function (lineItem) {
          if (lineItem) {
            // Remember the confirmed per-unit price so the next optimistic
            // preview of this bundle starts at the right amount.
            var confirmedUnit = lineItem.final_price || (lineItem.quantity > 0 ? Math.round(lineItem.final_line_price / lineItem.quantity) : 0);

            if (confirmedUnit) {
              try {
                var cache = readCache();
                cache[handle] = cache[handle] || {};
                cache[handle].finalUnitPrice = confirmedUnit;
                writeCache(cache);
              } catch (e) {
                /* ignore */
              }
            }

            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                button: button,
                variant: null,
                quantity: lineItem.quantity || 1,
                lineItem: lineItem,
                isFreight: false
              }
            }));
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { scrollToTop: false, skipLoadingStart: true }
            }));
          }
        });
      });
    })
      .catch(function (error) {
        finalize();
        var reason = error && error.message ? error.message : String(error);
        quickAddLog('failed for ' + handle, reason);
        showQuickAddError(button, 'Add failed (' + reason.slice(0, 80) + ')');
        document.documentElement.dispatchEvent(new CustomEvent('cart:add-failed', {
          bubbles: true,
          detail: { variantId: bapVariantId }
        }));

        // Unexpected failure (offer data missing, app API blocked, cart
        // rejected the add): turn the button into a "View Bundle" link so the
        // shopper still has a path, without a surprise navigation.
        if (!soldOut && productUrl) {
          button.textContent = 'View Bundle';
          button.setAttribute('data-action', 'view-bundle-fallback');
          button.setAttribute('data-product-url', productUrl);
        }
      });
  }

  document.addEventListener('click', function (event) {
    var fallbackLink = event.target.closest('[data-action="view-bundle-fallback"]');

    if (fallbackLink) {
      event.preventDefault();
      window.location.href = fallbackLink.getAttribute('data-product-url');
      return;
    }

    var button = event.target.closest('[data-action="quick-add-bundle"]');

    if (!button || button.disabled) {
      return;
    }

    event.preventDefault();
    quickAddBundle(button);
  });

  // --- Bundle pricing in the cart --------------------------------------------
  // A bundle is now added as a single line item (the BAP product). Its variant
  // price already reflects the bundle discount, but its compare-at does not show
  // the true retail "was" total (sum of each component's compare-at). We compute
  // that the same way as the cards/product page and show it as the struck price.

  var THEME_COMPARE_CACHE_KEY = 'themeVariantCompareAtCache';

  function readVariantCompareCache() {
    try {
      return JSON.parse(sessionStorage.getItem(THEME_COMPARE_CACHE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  // Seed the theme's own per-variant compare cache so its native mini-cart
  // re-renders (optimistic add, hydrate, refresh) keep showing our retail total
  // instead of stripping it.
  function seedVariantCompareCache(variantId, perUnitCents) {
    if (!variantId || !perUnitCents) {
      return;
    }

    try {
      var cache = readVariantCompareCache();

      if (cache[variantId] !== perUnitCents) {
        cache[variantId] = perUnitCents;
        sessionStorage.setItem(THEME_COMPARE_CACHE_KEY, JSON.stringify(cache));
      }
    } catch (e) {
      /* ignore quota errors */
    }
  }

  function renderMiniCartLineCompare(line, perUnitCents) {
    var qty = parseInt(line.getAttribute('data-quantity'), 10) || 1;
    var lineFinal = parseInt(line.getAttribute('data-line-price'), 10) || 0;
    var compareLine = perUnitCents * qty;

    if (compareLine <= lineFinal) {
      return;
    }

    var priceList = line.querySelector('.mini-cart__price-list');

    if (!priceList) {
      return;
    }

    var prices = priceList.parentNode;

    if (!prices || !prices.classList || !prices.classList.contains('mini-cart__prices')) {
      return;
    }

    // For a bundle, the retail total is the single "was" price. Drop the
    // theme's pre-bundle-discount original-line-price so it is not shown as a
    // second strikethrough (the bundle discount itself is shown as a badge).
    line.removeAttribute('data-original-line-price');
    line.removeAttribute('data-final-unit-price');

    var priceSpan = priceList.querySelector('.price');

    if (priceSpan && !priceSpan.classList.contains('price--highlight')) {
      priceSpan.classList.add('price--highlight');
    }

    var wasText = formatMoney(compareLine);

    // The Wholesale All In One / Fast Bundle apps inject a <del> compare inside
    // the price-list from the BAP variant compare-at (only the bundle discount).
    // If one is present, correct it to the true retail and don't add a duplicate.
    var appStrikes = priceList.querySelectorAll('del');

    if (appStrikes.length) {
      Array.prototype.forEach.call(appStrikes, function (node) {
        if (node.textContent !== wasText) {
          node.textContent = wasText;
        }
      });

      Array.prototype.forEach.call(prices.querySelectorAll('.mini-cart__was-price'), function (node) {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });

      return;
    }

    var wasNodes = prices.querySelectorAll('.mini-cart__was-price');

    // Idempotent: exactly one correct was-price already present -> stop, so the
    // MutationObserver reacting to our own writes settles immediately.
    if (wasNodes.length === 1 && wasNodes[0].textContent === wasText) {
      return;
    }

    Array.prototype.forEach.call(wasNodes, function (node) {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    var span = document.createElement('span');
    span.className = 'mini-cart__was-price';
    span.textContent = wasText;
    prices.appendChild(span);
  }

  // The main cart line price-list is rewritten by the Wholesale All In One and
  // Fast Bundle apps, which print a <del> compare from the BAP variant
  // compare-at (only the bundle discount). Rather than fight their full render,
  // we just correct the strike-through value(s) to the true component retail and
  // let a MutationObserver re-apply it whenever the apps re-render.
  function correctStrikes(scope, wantCents) {
    if (!scope) {
      return false;
    }

    var wantText = formatMoney(wantCents);
    var strikes = scope.querySelectorAll('del, .line-item__price--compare');

    if (!strikes.length) {
      return false;
    }

    Array.prototype.forEach.call(strikes, function (strike) {
      if (strike.textContent !== wantText) {
        strike.textContent = wantText;
      }
    });

    return true;
  }

  function renderMainCartLineCompare(line, perUnitCents) {
    var finalUnit = parseInt(line.getAttribute('data-final-price'), 10) || 0;
    var qty = parseInt(line.getAttribute('data-quantity'), 10) || 1;

    if (!finalUnit || perUnitCents <= finalUnit) {
      return;
    }

    // Unit price (shown under the product title).
    var priceList = line.querySelector('.line-item__price-list');

    if (priceList && !correctStrikes(priceList, perUnitCents)) {
      var compare = document.createElement('span');
      compare.className = 'line-item__price line-item__price--compare';
      compare.textContent = formatMoney(perUnitCents);
      priceList.appendChild(compare);
    }

    // Line total (shown in the "Total" column); compare = retail * quantity.
    var lineTotalCell = line.querySelector('.line-item__line-price');
    correctStrikes(lineTotalCell, perUnitCents * qty);
  }

  // Per-unit retail compare for a bundle line. The BAP variant's own
  // compare-at only reflects the extra bundle discount (not the components'
  // retail), so we always compute it from the component default/locked variants
  // -- consistent with the cards and the bundle product page.
  function resolveLineCompareUnit(line) {
    var handle = line.getAttribute('data-product-handle');

    if (!handle) {
      return Promise.resolve(0);
    }

    return resolveCompareCents(handle).catch(function () {
      return 0;
    });
  }

  function enhanceCartBundleLines() {
    var lines = document.querySelectorAll(
      '.mini-cart__line-item[data-is-bundle="true"], .line-item[data-is-bundle="true"]'
    );

    if (!lines.length) {
      return;
    }

    Array.prototype.forEach.call(lines, function (line) {
      var variantId = line.getAttribute('data-variant-id');
      var isMini = line.classList.contains('mini-cart__line-item');

      resolveLineCompareUnit(line)
        .then(function (perUnitCents) {
          if (!perUnitCents) {
            return;
          }

          line.setAttribute('data-compare-unit-price', perUnitCents);
          line.setAttribute('data-product-compare-at-price', perUnitCents);
          seedVariantCompareCache(variantId, perUnitCents);

          if (isMini) {
            renderMiniCartLineCompare(line, perUnitCents);
          } else {
            renderMainCartLineCompare(line, perUnitCents);
          }
        })
        .catch(function () {
          /* leave plain price if enhancement fails */
        });
    });
  }

  var cartInitDone = false;

  function runCart() {
    enhanceCartBundleLines();

    if (cartInitDone) {
      return;
    }

    cartInitDone = true;

    // Re-apply after the main cart section re-renders (this event bubbles).
    document.addEventListener('cart:rerendered', function () {
      enhanceCartBundleLines();
    });

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    // The mini-cart re-render swaps its inner content and the optimistic
    // add/quantity flow rebuilds line items; the cart page price-lists are
    // rewritten by the Wholesale All In One / Fast Bundle apps. Observe the
    // stable containers so we re-apply the correct retail compare after every
    // rebuild. Renders are idempotent so the observer reacting to our own
    // writes settles immediately.
    var observerTargets = [
      document.querySelector('.mini-cart'),
      document.querySelector('.line-item-table'),
      document.querySelector('[data-section-type="cart"]')
    ];

    var scheduled = false;
    var reapply = function () {
      if (scheduled) {
        return;
      }

      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        enhanceCartBundleLines();
      });
    };

    observerTargets.forEach(function (target) {
      if (target) {
        new MutationObserver(reapply).observe(target, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    });
  }

  function run() {
    runCart();

    var cards = document.querySelectorAll('.product-item[data-is-bundle="true"]');
    var pagePrice = document.querySelector('.product-meta__price[data-bundle-needs-compare="true"]');

    if (!cards.length && !pagePrice) {
      return;
    }

    var waitAttempts = 0;
    var waitTimer = setInterval(function () {
      waitAttempts += 1;

      if (window.FastBundleConf && window.FastBundleConf.storefront_access_token) {
        clearInterval(waitTimer);
        Array.prototype.forEach.call(cards, function (card) {
          enhanceBundleCard(card);
        });

        if (pagePrice) {
          setupBundlePageLivePricing(pagePrice);
        }
      } else if (waitAttempts > 40) {
        clearInterval(waitTimer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
